import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { UsersService } from '../../services/user';
import { AuthService, LanguagesService } from "@easyfo/common-lib";

@Component({
  selector: 'app-login',
  template: `
  <ng-container [ngSwitch]='true'>
    <ng-container *ngSwitchCase="currentView === 'mobile'">
      <app-login-mobile></app-login-mobile>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <app-login-desktop></app-login-desktop>
    </ng-container>
  </ng-container>`
})
export class LoginComponent implements OnInit {
  constructor(
    protected _titleService: Title,
    protected _userService: UsersService,
    protected _authService: AuthService,
    protected _languagesService: LanguagesService,
    protected _router: Router
  ) {
    this._titleService.setTitle("Login");
    this._languagesService.setDefault();
    if (window.innerWidth < 1200) {
      this.currentView = "mobile";
    } else {
      this.currentView = "desktop";
    }
  }

  currentView: "desktop" | "mobile";

  loginFailMessage!: string | undefined;
  showAlertBox: boolean = false;
  alertMessage?: string = "";
  submiting: boolean = false;
  username!: string;
  password!: string;
  hide: boolean = true;
  isRememberMe: boolean = false;

  ngOnInit(): void {
    if (this._authService.isLogin()) {
      this._authService.redirectToLandingPage();
    } else {
      this._userService.reloadAndGetUser().then((user) => {
        if (user.emailVerified) {
          this.loginSystem();
        } else {
          this._authService.clearSession();
          this._userService.logoutFirebase();
        }
      }).catch(() => {
        this._authService.clearSession();
        this._userService.logoutFirebase();
      });
    }

    this._languagesService.getText("form_login_app.form_login.fail_msg", (text: string | undefined) => {
      this.loginFailMessage = text;
    });
  }

  async onLoginClick() {
    this.submiting = true;
    this.showAlertBox = false;

    try {
      const result = await this._userService.loginFirebase(this.username, this.password);
      if (!result.success) {
        this.showAlertAndClearPasswaord();
        return;
      }

      if (result.user?.emailVerified) {
        this.loginSystem();
      } else {
        this._router.navigate(["/email-verification"]);
      }
    } catch (error) {
      this.showAlertAndClearPasswaord();
    }
  }

  async loginSystem() {
    const resLogin = await this._userService.requestLogin(this.username, this.password, this.isRememberMe);
    if (resLogin == true) {
      this._router.navigate(["/landing"]);
    } else {
      this.showAlertAndClearPasswaord();
    }
  }

  showAlertAndClearPasswaord() {
    this.password = '';
    this.submiting = false;
    this.showAlertBox = true;
    if ((this._userService.alertMsg != undefined) && (this._userService.alertMsg != "")) {
      this.alertMessage = this._userService.alertMsg;
    } else {
      this.alertMessage = this.loginFailMessage;
    }
  }
}


@Component({
  selector: "app-login-desktop",
  templateUrl: "./desktop/login-desktop.html",
  styleUrls: ["./desktop/login-desktop.css"]
})
export class LoginDesktopComponent extends LoginComponent {
  constructor(
    protected override _titleService: Title,
    protected override _userService: UsersService,
    protected override _authService: AuthService,
    protected override _languagesService: LanguagesService,
    protected override _router: Router) {
    super(_titleService, _userService, _authService, _languagesService, _router);
  }
}

@Component({
  selector: "app-login-mobile",
  templateUrl: "./mobile/login-mobile.html",
  styleUrls: ["./mobile/login-mobile.css"]
})
export class LoginMobileComponent extends LoginComponent {
  constructor(
    protected override _titleService: Title,
    protected override _userService: UsersService,
    protected override _authService: AuthService,
    protected override _languagesService: LanguagesService,
    protected override _router: Router) {
    super(_titleService, _userService, _authService, _languagesService, _router);
  }
}